import { shallowRef } from "vue";
import { dialogInjectionKey } from "../composables/useDialogs";
import type { DialogState } from "../types";
import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin( {
  name: "apollo-dialogs",
  parallel: true,
  setup ( nuxtApp ) {
    const dialogState = shallowRef<DialogState>( {
      component: "div",
      props: {},
    } );
    nuxtApp.vueApp.provide( dialogInjectionKey, dialogState );
  },
} );
